import { Box, CircularProgress } from "@mui/material";
import Download2LineIcon from "remixicon-react/Download2LineIcon";
import Upload2LineIcon from "remixicon-react/Upload2LineIcon";
import { useState } from "react";
import useJStyles from "$hooks/useJStyles";
import { useStyles } from "../Stock.styles";
import useAuth from "$hooks/useAuth";
import { Button } from "$components";
import { useDataPagination } from "$components/DataTable";
import { useJobs } from "$hooks/useJobs";
import { JobType } from "$types/Job";
import { ModalPatch } from "./ModalPatch";
import useCompanyStock from "$hooks/Stock/useCompanyStock";

export const CompanyStockInfo = ({ company, companyId, contributor }: any) => {
  const { jclasses } = useJStyles();
  const classes = useStyles();
  const { isAdmin } = useAuth();
  const { filters } = useDataPagination();
  const { startJob } = useJobs();

  const [isLoading, setIsLoading] = useState(false);
  const patchUseCompany = useCompanyStock(companyId, contributor);

  const buttonList = [
    ...(isAdmin()
      ? [
          <Button
            key="import"
            variant="outlined"
            onClick={patchUseCompany.onMassImportClick}
            startIcon={<Download2LineIcon />}
          >
            Importer en masse
          </Button>,
        ]
      : []),

    <Button
      key="export"
      variant="outlined"
      className={classes.btnRight}
      startIcon={
        isLoading ? <CircularProgress size={20} /> : <Upload2LineIcon />
      }
      disabled={isLoading}
      onClick={async () => {
        setIsLoading(true);
        try {
          await startJob({
            type: JobType.EXPORT_STOCK,
            label: "Export stocks",
            params: {
              companyId,
              companyName: company?.name ?? "",
              filters,
              fileName: `Liste des stocks ${company?.name ?? ""}`.trim(),
            },
          });
        } catch (error) {
          console.error("Error exporting stocks:", error);
        } finally {
          setIsLoading(false);
        }
      }}
    >
      Exporter
    </Button>,
  ];

  return (
    <>
      <Box className={jclasses.jBeforePaper}>
        <Box className={classes.rowStock}>
          {/*
        //TODO this is remove for the moment, info wasn't pertinent anyway
        <Box className={classes.rowStockEntrepot}>
          <Typography variant="inherit">
          <Text type="important">Stock par entrepôt : </Text>
          {`Vous avez ${quantities} unité${
            quantities > 1 ? "s" : ""
          } en stock`}
          </Typography>
          </Box>
        */}

          {/* {isAdmin() && (
            <Box>
              <Text type="important">Stock mis à jour :</Text>
              &nbsp;
              {`${0}/${warehouseTotal}`}
            </Box>
          )} */}
        </Box>
        {buttonList}
      </Box>
      <ModalPatch {...patchUseCompany} companyId={companyId} />
    </>
  );
};
